import React, {useState} from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";

import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";
import {useMapFeaturesContext} from "@ui/leafletCustom/context/mapContext/hooks/useMapFeaturesContext";
import {LatLng} from 'leaflet';
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import SelectPointFromAndToMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/selectPointsFromAndTo/SelectPointFromAndToMutateSingleVoyage";
import {
    OnSelectPointsFromAndToCb
} from "@containers/singleVoyage/mutateVoyage/points/selectPointsFromAndTo/types/events";
import PositionsDraggableCorrectionPointsSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/changeCorrectionPoints/PositionsDraggableCorrectionPointsSingleVoyage";
import {
    onSaveCorrectionPointsSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/types/events";
import {
    useRebuildPointsAndPositionsMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/useRebuildPointsAndPositionsMutateSingleVoyage";


const ChangeCorrectionPointsWithSelectPointMutateSingleVoyage = () => {

    const {points, setTargetPointId} = useRootContextMutateSingleVoyage()
    const {
        isPending,
        onRebuild,
    } = useRebuildPointsAndPositionsMutateSingleVoyage()

    const {mapFeatures} = useMapFeaturesContext()

    const {setMode} = useViewContextMutateSingleVoyage()

    const [targetPoints, setTargetPoints] = useState<{
        from: IWayPointCreationWithCorrectionsSingleVoyage,
        to: IWayPointCreationWithCorrectionsSingleVoyage,
    } | null>(null)

    const onSelectPoints: OnSelectPointsFromAndToCb = ({
                                                           from,
                                                           to,
                                                           fromIndex,
                                                           toIndex,
                                                       }) => {
        setTargetPoints({
            from: {
                ...from,
                plannedOrdinal: fromIndex,
            },
            to: {
                ...to,
                plannedOrdinal: toIndex,
            }
        })
        const {lat, lng} = getLatLngFromPointGeomCoordinates(from?.geom)
        mapFeatures.setView(new LatLng(lat, lng), 15)
    }

    const onSave: onSaveCorrectionPointsSingleVoyage = async ({
                                                                  points: correctionWaypoints,
                                                                  fromPoint,
                                                              }) => {
        setMode('points')
        setTargetPointId(fromPoint.id?.toString())
        await onRebuild({
            points: points?.map((item) => {
                if (item.id === fromPoint.id) {
                    return {
                        ...item,
                        correctionWaypoints
                    }
                }
                return item
            }),
        })
    }

    return (
        <>
            {!targetPoints?.from && <SelectPointFromAndToMutateSingleVoyage
                points={points}
                onSelect={onSelectPoints}
                onCancel={() => setMode('points')}
            />}


            {targetPoints?.from && <PositionsDraggableCorrectionPointsSingleVoyage
                fromPoint={targetPoints.from}
                toPoint={targetPoints.to}
                onSave={onSave}
                disabled={isPending}
            />}
        </>
    );
};

export default ChangeCorrectionPointsWithSelectPointMutateSingleVoyage;
